import config from 'config';

let widgetId: string | null = null;

/** Single #captcha container; concurrent calls would remove each other's widget (e.g. `/registry/:uid` loads list + detail at once). */
let turnstileMutex: Promise<void> = Promise.resolve();

function getTurnstile() {
  const ts = (window as any).turnstile;
  if (!ts) throw new Error('Turnstile script not loaded');
  return ts;
}

export async function getCaptchaToken(): Promise<string> {
  let releaseNext!: () => void;
  const nextWaiter = new Promise<void>((resolve) => {
    releaseNext = resolve;
  });
  const previous = turnstileMutex;
  turnstileMutex = nextWaiter;
  await previous;

  try {
    const turnstile = getTurnstile();

    await new Promise<void>((resolve) => {
      turnstile.ready(resolve);
    });

    const el = document.querySelector('#captcha');
    if (!el) throw new Error('#captcha element not found');

    return await new Promise((resolve, reject) => {
      if (widgetId !== null) {
        turnstile.remove(widgetId);
        widgetId = null;
      }

      widgetId = turnstile.render(el, {
        sitekey: config.captcha.key,
        callback: (token: string) => {
          resolve(token);
        },
        'error-callback': () => {
          reject(new Error('CAPTCHA failed'));
        },
        'expired-callback': () => {
          reject(new Error('CAPTCHA expired'));
        }
      });

      turnstile.execute(widgetId);
    });
  } finally {
    releaseNext();
  }
}